
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {
  CodeSurfer,
  CodeSurferColumns,
  Step,
} from "code-surfer";
import { github, vsDark } from "@code-surfer/themes";
import {
  Notes,
  Head,
  Appear,
  Split,
  Invert,
} from "mdx-deck";
import {
  Meta,
  Profile,
  Page,
  Colors,
  Heading,
  SubHeading,
  Paragraph,
  MarginBottom,
  Circle,
  Row,
  Center,
} from "./src";
import ReactNative from "./react-native.png";
import MyPic from "./images/my-pic.jpg";
import CureAppLogo from "./images/cureapp-logo.png";
import TwitterLogo from "./images/twitter-logo.png";
import GithubLogo from "./images/github-logo.png";
import VisRegDiff from "./images/vis-reg-diff.png";
import VisRegSide from "./images/vis-reg-diff-2.png";
import VisRegReport from "./images/vis-reg-report.png";
import RegSuitLogo from "./images/reg-suit-logo.jpg";
import StorybookLogo from "./images/storybook-logo.svg";
import CureAppTech from "./images/cureapp-tech.png";
import LightTheme from "./images/light-theme.png";
import DarkTheme from "./images/dark-theme.png";
import Branches from "./images/branches.svg";
import {
  View,
  Text,
  TouchableOpacity,
  Platform,
  ActivityIndicator,
  StyleSheet,
  Image,
} from "react-native-web";
export const theme = { ...vsDark,
  fonts: {
    body: "-apple-system, system-ui, sans-serif"
  }
};

const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Head mdxType="Head">
  <title>Visual Regression Test in React Native</title>
  <meta property="og:locale" content="ja_JP" />
  <meta property="og:title" content="Visual Regression Test in React Native" />
  <meta property="og:description" content="Introduction to React Native" />
  <meta property="og:type" content="article" />
  <meta property="og:url" content="https://visual-regression-test-in-react-native.now.sh/assets/oembed.json" />
  <meta property="og:image" content="https://visual-regression-test-in-react-native.now.sh/assets/card.png" />
  <meta property="article:published_time" content="2020-08-06T14:46:16.704Z" />
  <meta property="article:author" content="naturalclar" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:site" content="@Naturalclar" />
  <meta name="twitter:title" content="Visual Regression Test in React Native" />
  <meta name="twitter:description" content="Visual Regression Test in React Native" />
  <meta name="twitter:image" content="https://visual-regression-test-in-react-native.now.sh/assets/card.png" />
  <link rel="alternate" type="application/json+oembed" href={`https://visual-regression-test-in-react-native.now.sh/assets/oembed.json`} title="Visual Regression Test in React Native" />
    </Head>
    <Page mdxType="Page">
  <View style={{
        flex: 1,
        justifyContent: "flex-end"
      }} mdxType="View">
    <Heading mdxType="Heading">
      <Text style={{
            color: Colors.baseTextColor
          }} mdxType="Text">
        Visual Regression Test{" "}
      </Text>
      <Text style={{
            color: "#d081c4"
          }} mdxType="Text">for</Text> <Text style={{
            color: Colors.secondaryColor
          }} mdxType="Text">React Native</Text>
    </Heading>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <Paragraph style={{
          color: Colors.secondaryColor
        }} mdxType="Paragraph">
      @natural_clar
    </Paragraph>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <Paragraph mdxType="Paragraph">React Native EU 2020</Paragraph>
  </View>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Agenda</SubHeading>
  <Row style={{
        flex: 1,
        justifyContent: "space-evenly"
      }} mdxType="Row">
    <Circle mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Introduction
      </Paragraph>
    </Circle>
    <Circle mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        What is a
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Visual
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Regression
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Test?
      </Paragraph>
    </Circle>
    <Circle mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        How do I
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        perform it with
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        React Native?
      </Paragraph>
    </Circle>
    <Circle mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Demo! 🚀
      </Paragraph>
    </Circle>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Hello! 👋</SubHeading>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Paragraph mdxType="Paragraph">
    I'm{" "}
    <Text style={{
          fontWeight: "600"
        }} mdxType="Text">
      Jesse Katsumata
    </Text>
  </Paragraph>
  <MarginBottom size={8} mdxType="MarginBottom" />
  <Row mdxType="Row">
    <View style={{
          width: 32,
          height: 32,
          justifyContent: "center",
          alignItems: "center",
          marginRight: 8
        }} mdxType="View">
      <img src={TwitterLogo} />
    </View>
    <Paragraph mdxType="Paragraph">@natural_clar</Paragraph>
  </Row>
  <MarginBottom size={8} mdxType="MarginBottom" />
  <Row mdxType="Row">
    <View style={{
          width: 32,
          height: 32,
          justifyContent: "center",
          alignItems: "center",
          marginRight: 8
        }} mdxType="View">
      <img src={GithubLogo} />
    </View>
    <Paragraph mdxType="Paragraph">@Naturalclar</Paragraph>
  </Row>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Paragraph mdxType="Paragraph">
    Software Engineer at{" "}
    <Text style={{
          fontWeight: "600"
        }} mdxType="Text">CureApp, Inc.</Text>
  </Paragraph>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Paragraph mdxType="Paragraph">
    Member of{" "}
    <Text style={{
          fontWeight: "600"
        }} mdxType="Text">
      react-native-community
    </Text>
  </Paragraph>
  <MarginBottom size={8} mdxType="MarginBottom" />
  <Paragraph mdxType="Paragraph">maintaining some Lean Core modules</Paragraph>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Paragraph mdxType="Paragraph">❤️ OSS & Music 🎹</Paragraph>
  <View style={{
        position: "absolute",
        height: 240,
        width: 240,
        top: "20%",
        right: "20%",
        transform: [{
          rotate: "-20deg"
        }]
      }} mdxType="View">
    <img src={MyPic} width="50%" />
  </View>
  <View style={{
        position: "absolute",
        height: 240,
        width: 240,
        top: "60%",
        right: "20%"
      }} mdxType="View">
    <img src={CureAppLogo} width="50%" />
  </View>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <Row mdxType="Row">
    <Center mdxType="Center">
      <View style={{
            flex: 1,
            width: 240,
            height: 240
          }} mdxType="View">
        <img src={CureAppLogo} />
      </View>
    </Center>
    <Center mdxType="Center">
      <View style={{
            flex: 1,
            width: "100%",
            height: "50%"
          }} mdxType="View">
        <img src={CureAppTech} />
      </View>
    </Center>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Some of Tests we perform</SubHeading>
  <Row style={{
        flex: 1,
        justifyContent: "space-evenly"
      }} mdxType="Row">
    <Circle mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Unit Tests
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Tests
      </Paragraph>
    </Circle>
    <Circle mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Integration
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Tests
      </Paragraph>
    </Circle>
    <Circle style={{
          backgroundColor: Colors.secondaryColor
        }} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        UI Tests
      </Paragraph>
    </Circle>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <Center mdxType="Center">
    <Heading mdxType="Heading">UI Testing</Heading>
  </Center>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <Row mdxType="Row">
    <View style={{
          width: "100%",
          height: "100%",
          flex: 1
        }} mdxType="View">
      <SubHeading mdxType="SubHeading">UI Testing</SubHeading>
      <ul>
        <li style={{
              color: Colors.baseTextColor,
              marginBottom: 16
            }}>
          it..
        </li>
        <ul>
          <li style={{
                color: Colors.baseTextColor,
                marginBottom: 16
              }}>
            Displays an email input form
          </li>
          <li style={{
                color: Colors.baseTextColor,
                marginBottom: 16
              }}>
            Displays a password input form
          </li>
          <li style={{
                color: Colors.baseTextColor,
                marginBottom: 16
              }}>
            Displays a Login Button
          </li>
          <li style={{
                color: Colors.baseTextColor,
                marginBottom: 16
              }}>
            Has disabled button if a form is empty
          </li>
          <li style={{
                color: Colors.baseTextColor,
                marginBottom: 16
              }}>
            Displays loading on network request
          </li>
          <li style={{
                color: Colors.secondaryColor,
                marginBottom: 16
              }}>
            Looks the way you intended
          </li>
          <li style={{
                color: Colors.baseTextColor,
                marginBottom: 16
              }}>
            etc...
          </li>
        </ul>
      </ul>
    </View>
    <Center mdxType="Center">
      <View style={{
            width: 320,
            height: 480,
            borderWidth: 1,
            borderColor: Colors.baseTextColor,
            borderRadius: 5,
            padding: 24,
            alignItems: "center",
            justifyContent: "space-between"
          }} mdxType="View">
        <View style={{
              alignSelf: "stretch"
            }} mdxType="View">
          <Text style={{
                color: Colors.baseTextColor,
                fontSize: 24
              }} mdxType="Text">
            Awesome App Login
          </Text>
          <MarginBottom size={48} mdxType="MarginBottom" />
          <Text style={{
                color: Colors.baseTextColor
              }} mdxType="Text">
            email
          </Text>
          <MarginBottom size={24} mdxType="MarginBottom" />
          <View style={{
                borderBottomColor: Colors.baseTextColor,
                borderBottomWidth: 1
              }} mdxType="View" />
          <MarginBottom size={24} mdxType="MarginBottom" />
          <Text style={{
                color: Colors.baseTextColor
              }} mdxType="Text">
            password
          </Text>
          <MarginBottom size={24} mdxType="MarginBottom" />
          <View style={{
                borderBottomColor: Colors.baseTextColor,
                borderBottomWidth: 1
              }} mdxType="View" />
        </View>
        <View mdxType="View">
          <Row mdxType="Row">
            <View style={{
                  width: 240,
                  height: 60,
                  padding: 24,
                  borderRadius: 24,
                  borderWidth: 1,
                  alignItems: "center",
                  justifyContent: "center",
                  borderColor: Colors.baseTextColor
                }} mdxType="View">
              <Text style={{
                    color: Colors.baseTextColor
                  }} mdxType="Text">
                Login
              </Text>
            </View>
          </Row>
          <MarginBottom size={16} mdxType="MarginBottom" />
          <Row mdxType="Row">
            <View style={{
                  width: 240,
                  height: 60,
                  padding: 24,
                  borderRadius: 24,
                  borderWidth: 1,
                  alignItems: "center",
                  justifyContent: "center",
                  borderColor: Colors.baseTextColor
                }} mdxType="View">
              <Text style={{
                    color: Colors.baseTextColor
                  }} mdxType="Text">
                Login with SNS
              </Text>
            </View>
          </Row>
        </View>
      </View>
    </Center>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">UI Testing</SubHeading>
  <Row style={{
        flex: 1,
        justifyContent: "space-evenly"
      }} mdxType="Row">
    <Circle size={240} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Snapshot
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Testing
      </Paragraph>
    </Circle>
    <Circle size={240} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Interaction
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Testing
      </Paragraph>
    </Circle>
    <Circle style={{
          backgroundColor: Colors.secondaryColor
        }} size={240} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Visual
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Regression
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Testing
      </Paragraph>
    </Circle>
    <Circle size={240} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        etc...
      </Paragraph>
    </Circle>
  </Row>
    </Page>
    <hr></hr>
    <CodeSurferColumns themes={[github, vsDark]} mdxType="CodeSurferColumns">
      <Step mdxType="Step">
        <pre><code parentName="pre" {...{
            "className": "language-jsx"
          }}>{`// source: https://jestjs.io/docs/en/tutorial-react-native
// __tests__/Intro-test.js

import React from "react";
import Intro from "../Intro";

import renderer from "react-test-renderer";

test("renders correctly", () => {
  const tree = renderer.create(<Intro />).toJSON();
  expect(tree).toMatchSnapshot();
});
`}</code></pre>
        <div>
  <h1>Snapshot Testing</h1>
        </div>
      </Step>
      <Step mdxType="Step">
        <pre><code parentName="pre" {...{
            "className": "language-jsx"
          }}>{`// source: https://jestjs.io/docs/en/tutorial-react-native
// __tests__/__snapshots__/Intro-test.js.snap

exports[\`Intro renders correctly 1\`] = \`
<View
  style={
    Object {
      "alignItems": "center",
      "backgroundColor": "#F5FCFF",
      "flex": 1,
      "justifyContent": "center",
    }
  }>
  <Text
    style={
      Object {
        "fontSize": 20,
        "margin": 10,
        "textAlign": "center",
      }
    }>
    Welcome to React Native!
  </Text>
  <Text
    style={
      Object {
        "color": "#333333",
        "marginBottom": 5,
        "textAlign": "center",
      }
    }>
    This is a React Native snapshot test.
  </Text>
</View>
\`;
`}</code></pre>
        <div>
  <h1>Snapshot Testing</h1>
        </div>
      </Step>
      <Step mdxType="Step">
        <pre><code parentName="pre" {...{
            "className": "language-jsx"
          }}>{`// source: https://callstack.com/blog/react-native-testing-library-with-redux/
// SignUpScreen.test.tsx

test('User cannot SignUp with wrong credentials', async () => {
  mockSignUpApi.mockImplementationOnce(() =>
    Promise.resolve({
      status: 401,
      data: {
        error: { 'Invalid username or password' }
      }
    }),
  );

  const screen = renderSignUpScreen();

  fireEvent.changeText(screen.getByPlaceholder(/Username/i), 'user@callstack.com');
  fireEvent.changeText(screen.getByPlaceholder(/Password/i), 'Incorrect Password');
  fireEvent.press(screen.getByText('SignUp'));

  expect(mockSignUpApi).toHaveBeenCalledTimes(1);
  expect(mockSignUpApi).toHaveBeenCalledWith({
    username: 'user@callstack.com',
    password: 'Incorrect Password',
  });
  expect(await screen.findByText('Invalid username or password')).toBeTruthy();
});
`}</code></pre>
        <div>
  <h1>Interaction Testing</h1>
        </div>
      </Step>
    </CodeSurferColumns>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Visual Regression Testing</SubHeading>
  <Row mdxType="Row">
    <Center mdxType="Center">
      <View style={{
            flex: 1,
            width: "65%"
          }} mdxType="View">
        <img src={VisRegDiff} />
      </View>
    </Center>
    <Center style={{
          flex: 2
        }} mdxType="Center">
      <View style={{
            flex: 1,
            width: "60%"
          }} mdxType="View">
        <img src={VisRegSide} />
      </View>
    </Center>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Visual Regression Testing</SubHeading>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Center mdxType="Center">
    <View style={{
          flex: 1,
          width: "80%"
        }} mdxType="View">
      <img src={Branches} />
    </View>
  </Center>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Visual Regression Testing</SubHeading>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Center mdxType="Center">
    <View style={{
          flex: 1,
          width: "80%"
        }} mdxType="View">
      <img src={VisRegReport} />
    </View>
  </Center>
    </Page>
    <hr></hr>
    <CodeSurferColumns themes={[github, vsDark]} mdxType="CodeSurferColumns">
      <Step mdxType="Step">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "subtitle=\"SignUp Page\"",
            "subtitle": "\"SignUp",
            "Page\"": true
          }}>{`// SignUpPage.tsx
import React from "react";
import { Page, SignUpForm, PrimaryButton } from "../src";

export const SignUpPage = () => {
  return (
    <Page>
      <SignUpForm />
      <PrimaryButton label={"SignUp"} onPress={SignUp} />
    </Page>
  );
};
`}</code></pre>
        <View style={{
          width: 320,
          height: 480,
          borderWidth: 1,
          borderColor: "white",
          borderRadius: 5,
          padding: 24,
          alignItems: "center",
          justifyContent: "space-between"
        }} mdxType="View">
  <View style={{
            alignSelf: "stretch"
          }} mdxType="View">
    <Text style={{
              color: "white",
              fontSize: 24
            }} mdxType="Text">
      Awesome App Signup
    </Text>
    <MarginBottom size={48} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">email</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
    <MarginBottom size={24} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">password</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
  </View>
  <View style={{
            width: 150,
            height: 60,
            padding: 24,
            borderRadius: 24,
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "white"
          }} mdxType="View">
    <Text style={{
              color: "white"
            }} mdxType="Text">SignUp</Text>
  </View>
        </View>
      </Step>
      <Step mdxType="Step">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "subtitle=\"PrimaryButton\"",
            "subtitle": "\"PrimaryButton\""
          }}>{`// PrimaryButton.tsx
import React from "react";
import { View, Text } from "react-native";

export const PrimaryButton = ({ label, onPress }) => {
  return (
    <TouchableOpacity
      style={{
        width: 150,
        height: 60,
        padding: 24,
        borderRadius: 24,
        borderWidth: 1,
        alignItems: "center",
        justifyContent: "center",
        borderColor: "white",
      }}
    >
      <Text>{label}</Text>
    </TouchableOpacity>
  );
};
`}</code></pre>
        <View style={{
          width: 320,
          height: 480,
          borderWidth: 1,
          borderColor: "white",
          borderRadius: 5,
          padding: 24,
          alignItems: "center",
          justifyContent: "space-between"
        }} mdxType="View">
  <View style={{
            alignSelf: "stretch"
          }} mdxType="View">
    <Text style={{
              color: "white",
              fontSize: 24
            }} mdxType="Text">
      Awesome App Signup
    </Text>
    <MarginBottom size={48} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">email</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
    <MarginBottom size={24} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">password</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
  </View>
  <View style={{
            width: 150,
            height: 60,
            padding: 24,
            borderRadius: 24,
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "white"
          }} mdxType="View">
    <Text style={{
              color: "white"
            }} mdxType="Text">SignUp</Text>
  </View>
        </View>
      </Step>
      <Step mdxType="Step">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "subtitle=\"PrimaryButton\"",
            "subtitle": "\"PrimaryButton\""
          }}>{`// PrimaryButton.tsx
import React from "react";
import { View, Text } from "react-native";

export const PrimaryButton = ({ label, onPress }) => {
  return (
    <TouchableOpacity
      style={{
        width: 240,
        height: 60,
        padding: 24,
        borderRadius: 24,
        borderWidth: 1,
        alignItems: "center",
        justifyContent: "center",
        borderColor: "white",
      }}
    >
      <Text>{label}</Text>
    </TouchableOpacity>
  );
};
`}</code></pre>
        <View style={{
          width: 320,
          height: 480,
          borderWidth: 1,
          borderColor: "white",
          borderRadius: 5,
          padding: 24,
          alignItems: "center",
          justifyContent: "space-between"
        }} mdxType="View">
  <View style={{
            alignSelf: "stretch"
          }} mdxType="View">
    <Text style={{
              color: "white",
              fontSize: 24
            }} mdxType="Text">
      Awesome App Signup
    </Text>
    <MarginBottom size={48} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">email</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
    <MarginBottom size={24} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">password</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
  </View>
  <View style={{
            width: 240,
            height: 60,
            padding: 24,
            borderRadius: 24,
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "white"
          }} mdxType="View">
    <Text style={{
              color: "white"
            }} mdxType="Text">SignUp</Text>
  </View>
        </View>
      </Step>
      <Step mdxType="Step">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "subtitle=\"Login Page\"",
            "subtitle": "\"Login",
            "Page\"": true
          }}>{`// PrimaryButton.tsx
import React from "react";
import { View, Text } from "react-native";
import {
  Page,
  LoginForm,
  Row,
  PrimaryButton,
} from "../src";

export const LoginPage = () => {
  return (
    <Page>
      <LoginForm />
      <Row>
        <PrimaryButton
          label={"Register"}
          onPress={Register}
        />
        <PrimaryButton label={"Login"} onPress={Login} />
      </Row>
    </Page>
  );
};
`}</code></pre>
        <View style={{
          width: 320,
          height: 480,
          borderWidth: 1,
          borderColor: "white",
          borderRadius: 5,
          padding: 24,
          alignItems: "center",
          justifyContent: "space-between"
        }} mdxType="View">
  <View style={{
            alignSelf: "stretch"
          }} mdxType="View">
    <Text style={{
              color: "white",
              fontSize: 24
            }} mdxType="Text">
      Awesome App Login
    </Text>
    <MarginBottom size={48} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">email</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
    <MarginBottom size={24} mdxType="MarginBottom" />
    <Text style={{
              color: "white"
            }} mdxType="Text">password</Text>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <View style={{
              borderBottomColor: "white",
              borderBottomWidth: 1
            }} mdxType="View" />
  </View>
  <Row mdxType="Row">
    <View style={{
              width: 240,
              height: 60,
              padding: 24,
              borderRadius: 24,
              borderWidth: 1,
              alignItems: "center",
              justifyContent: "center",
              borderColor: "white"
            }} mdxType="View">
      <Text style={{
                color: "white"
              }} mdxType="Text">Register</Text>
    </View>
    <View style={{
              width: 240,
              height: 60,
              padding: 24,
              borderRadius: 24,
              borderWidth: 1,
              alignItems: "center",
              justifyContent: "center",
              borderColor: "white"
            }} mdxType="View">
      <Text style={{
                color: "white"
              }} mdxType="Text">Login</Text>
    </View>
  </Row>
        </View>
      </Step>
    </CodeSurferColumns>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Other Reasons</SubHeading>
  <Row style={{
        flex: 1,
        justifyContent: "space-evenly"
      }} mdxType="Row">
    <Circle size={360} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Prevent
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        False Positives
      </Paragraph>
    </Circle>
    <Circle size={360} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Refactor/Upgrade
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Component Library
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        with confidence 💪
      </Paragraph>
    </Circle>
    <Circle size={360} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">Test</Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Dark Mode 🌙
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        with ease
      </Paragraph>
    </Circle>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Supporting Dark Mode</SubHeading>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Row mdxType="Row">
    <Center mdxType="Center">
      <View style={{
            flex: 1,
            width: "80%"
          }} mdxType="View">
        <img src={LightTheme} />
      </View>
    </Center>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Supporting Dark Mode</SubHeading>
  <MarginBottom size={60} mdxType="MarginBottom" />
  <Row mdxType="Row">
    <Center mdxType="Center">
      <View style={{
            flex: 1,
            width: "80%"
          }} mdxType="View">
        <img src={LightTheme} />
      </View>
    </Center>
    <Center mdxType="Center">
      <View style={{
            flex: 1,
            width: "80%"
          }} mdxType="View">
        <img src={DarkTheme} />
      </View>
    </Center>
  </Row>
  <View style={{
        position: "absolute",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
      }} mdxType="View">
    <Circle size={300} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        2x as many
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        screens
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        to check!
      </Paragraph>
    </Circle>
  </View>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Why is it Important?</SubHeading>
  <Row style={{
        flex: 1,
        justifyContent: "space-evenly"
      }} mdxType="Row">
    <Circle size={360} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Reduce QA
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">Time</Paragraph>
    </Circle>
    <Circle size={360} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Automate
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Everything
      </Paragraph>
    </Circle>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <Center mdxType="Center">
    <Heading mdxType="Heading">
      How do I perform it with React Native?
    </Heading>
  </Center>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <img src={RegSuitLogo} />
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">REG SUIT</SubHeading>
  <Row style={{
        flex: 1,
        justifyContent: "space-evenly"
      }} mdxType="Row">
    <Circle size={320} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Compare Images
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">with</Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Parent Branch
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        on Pull Requests
      </Paragraph>
    </Circle>
    <Circle size={320} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Easy Setup
      </Paragraph>
    </Circle>
    <Circle size={320} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Store
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Screenshots
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        to Cloud
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        (S3, GCS)
      </Paragraph>
    </Circle>
    <Circle size={320} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Automatically
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Create Report
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        on Pull Requests
      </Paragraph>
    </Circle>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <SubHeading mdxType="SubHeading">Storybook + React Native Web</SubHeading>
  <Row style={{
        flex: 1,
        justifyContent: "space-evenly"
      }} mdxType="Row">
    <Circle size={320} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Faster Build
      </Paragraph>
    </Circle>
    <Circle size={320} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Easily check
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        for Dark Mode
      </Paragraph>
    </Circle>
    <Circle size={320} mdxType="Circle">
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        Can be
      </Paragraph>
      <Paragraph style={{
            color: "white"
          }} mdxType="Paragraph">
        reused for web
      </Paragraph>
    </Circle>
  </Row>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <Center mdxType="Center">
    <Heading mdxType="Heading">DEMO</Heading>
  </Center>
    </Page>
    <hr></hr>
    <Page mdxType="Page">
  <Center mdxType="Center">
    <Heading mdxType="Heading">THANK YOU!</Heading>
    <MarginBottom size={60} mdxType="MarginBottom" />
    <Paragraph mdxType="Paragraph">
      DEMO:
      https://github.com/Naturalclar/react-native-sketchbook
    </Paragraph>
    <MarginBottom size={8} mdxType="MarginBottom" />
    <Paragraph mdxType="Paragraph">
      Slides:
      https://github.com/Naturalclar/slide-react-native-eu-2020
    </Paragraph>
    <MarginBottom size={24} mdxType="MarginBottom" />
    <Row mdxType="Row">
      <View style={{
            width: 32,
            height: 32,
            justifyContent: "center",
            alignItems: "center",
            marginRight: 8
          }} mdxType="View">
        <img src={TwitterLogo} />
      </View>
      <Paragraph mdxType="Paragraph">@natural_clar</Paragraph>
    </Row>
    <MarginBottom size={8} mdxType="MarginBottom" />
    <Row mdxType="Row">
      <View style={{
            width: 32,
            height: 32,
            justifyContent: "center",
            alignItems: "center",
            marginRight: 8
          }} mdxType="View">
        <img src={GithubLogo} />
      </View>
      <Paragraph mdxType="Paragraph">@Naturalclar</Paragraph>
    </Row>
  </Center>
    </Page>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;